<template>
    <b-table
        class="data-table"
        :data="itenspedidoFormatado"
        @sort="$emit('sortTable')"
        @check="onChangeCheck"
        backend-sorting
        :checkable="tipoPedido != 'B' && isEditSituacao"
        :checked-rows.sync="itensSelecionados"
        :is-row-checkable="(row => row.autorizacaoSituacao === 1)"
        :custom-is-checked="(selecionado, item) => selecionado.id === item.id"
    >
        <b-table-column
            v-for="(f, i) in itemFields"
            :key="i"
            :field="f.key"
            :label="f.label ? $t(f.label) : ''"
            :width="f.width"
            :sortable="f.sortable"
            :custom-sort="f.sortFn"
            :numeric="f.numeric"
        >
            <template v-slot:header>
                <span v-if="f.label">
                    {{ $t(f.label) }}
                    <span
                        v-if="
                            f.key == 'qtde' ||
                            f.key == 'peso' ||
                            f.key == 'valortabpreco' ||
                            f.key == 'valorunitario' ||
                            f.key == 'valortotalbruto' ||
                            f.key == 'valortabpreco'
                        "
                    >
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="$t(`informacao-tooltip-valor-unitario`)"
                        />
                    </span>
                    <span v-if="f.key == 'saldogerado'">
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="$t(`saldo-gerado-item`)"
                        />
                    </span>
                </span>
            </template>
            <template v-slot="props">
                <div
                    :title="props.row[f.key]"
                    v-if="
                        f.key == 'qtde' ||
                        f.key == 'peso' ||
                        f.key == 'valortabpreco' ||
                        f.key == 'valorunitario' ||
                        f.key == 'valortotalbruto' ||
                        f.key == 'valortotal' ||
                        f.key == 'saldogerado'
                    "
                >
                    {{ props.row[f.key] ? getDecimal(props.row[f.key]) : "--" }}
                </div>
                <div 
                    v-else-if="tipoPedido != 'B' && f.key == 'critica' && props.row['autorizacaoSituacao'] === 1" 
                    class="bar vencidos"
                    v-tippy
                    :title="`${$t('critica')}: ${props.row[f.key] ? props.row[f.key] : '--'}`">
                </div>
                <div v-else-if="f.key == 'iditempedido'">
                    <div v-if="props.row[f.key] == '0'">
                        {{ props.row.idproduto }}
                    </div>
                    <div v-else-if="f.key == 'iditempedido'">
                        <div v-if="props.row[f.key] == '0'">
                            {{ props.row.idproduto }}
                        </div>
                        <div v-else-if="f.key == 'iditempedido'">
                            <div v-if="props.row[f.key] == '0'">
                                {{ props.row.idproduto }}
                            </div>
                            <div v-else>
                                {{ props.row.iditempedido }}
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="f.key == 'detalhe'">
                    <span
                        class="mr-2 clickable icon-position"
                        @click="$emit('idItemPedido', props.row.iditempedido)"
                    >
                        <b-icon
                            icon="playlist-check"
                            type="is-primary"
                            v-tippy
                            :title="$t('detalhe-item-pedido')"
                        />
                    </span>
                </div>
                <div v-else-if="f.key != 'critica'">
                    {{ props.row[f.key] }}
                </div>
            </template>
        </b-table-column>
    </b-table>
</template>

<script>
export default {
    props: {
        tipoPedido: String,
        itensPedido: Array,
        paramDescontoTriplo: Object,
        isEditSituacao: Boolean
    },
    data() {
        return {
            itenspedidoFormatado: [],
            itensSelecionados: [],
            itemFields: [
                { 
                    key: 'critica', 
                    width: null, 
                    sortable: false, 
                    cellClass: 'table-td-relative' 
                },
                {
                    key: "detalhe",
                    width: 6,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "status_pedido_retorno",
                    width: 6,
                    sortable: false,
                    sortFn: null,
                },
                {
                    key: "idprodutoerp",
                    label: "id-produto-erp",
                    width: 100,
                    sortable: false,
                    centered: true,
                },
                {
                    key: "produto",
                    label: "produto",
                    width: 200,
                    sortable: false,
                    centered: true,
                },
                {
                    key: "tipopedido",
                    label: "tipo-pedido",
                    width: 150,
                    sortable: false,
                    centered: true,
                },
                {
                    key: "qtde",
                    label: "qntde",
                    width: 100,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                // @84266 - Adicionado campo de peso x quantidade
                {
                    key: "peso",
                    label: "pesoxqtde",
                    width: 150,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "valortabpreco",
                    label: "valor-tabela",
                    width: 150,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "valorunitario",
                    label: "valor-venda",
                    width: 150,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "valortotalbruto",
                    label: "valor-total-bruto",
                    width: 180,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "valortotal",
                    label: "valor-total-liquido",
                    width: 180,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "saldogerado",
                    label: "saldo-gerado",
                    width: 150,
                    sortable: false,
                    numeric: true,
                    centered: true,
                },
                {
                    key: "motivo",
                    label: "motivo",
                    width: 200,
                    sortable: false,
                    centered: true,
                },
                {
                    key: "obsMotivo",
                    label: "motivo-obs",
                    width: 200,
                    sortable: false,
                    centered: true,
                },
            ],
        };
    },
    watch: {
        /**
         * @87876 - foi verificado que ao atualizar a prop itensPedido, não atualizava a tabela, criado
         * watch para quando o pai alterar os valores da propriedade o componente filho renderizar
         * as mudanças.
         */
        itensPedido(val) {
            this.itenspedidoFormatado = val;
            this.formatItens();
        }
    },
    created() {
        this.itenspedidoFormatado = this.itensPedido;
        this.formatItens();
    },
    methods: {
        clearItensSelecionados() {
            this.itensSelecionados = [];
        },
        getValorVenda(obj) {
            return this.getDescontoFormatado(obj.valorunitario, obj);
        },
        formatItens() {
            this.itenspedidoFormatado.map((item) => {
                item.valortotal = this.getValorTotalItem(item);
                item.valortotalbruto = this.getValorTotalBruto(item);
                item.valorunitario = this.getValorVenda(item);
                item.motivo = this.getMotivo(item);
                item.obsMotivo = this.getObsMotivo(item)
            });
        },
        getValorTotalItem(obj) {
            let qtd = obj.qtde;
            let valorItem = obj.valorunitario;
            let total = valorItem * qtd;

            total = this.getDescontoFormatado(total, obj);
            return total;
        },
        getValorTotalBruto(obj) {
            return obj.valortabpreco * obj.qtde;
        },
        onChangeCheck(e){
            this.$emit('onChangeCheck', e)
        },
        getDescontoFormatado(valor, obj) {
            if (
                !this.paramDescontoTriplo.valor ||
                this.paramDescontoTriplo.valor != 1
            ) {
                return valor;
            }

            valor = this.getDescontroTriplo(
                valor,
                obj.descontotriplo1,
                obj.descontotriplo2,
                obj.descontotriplo3
            );
            return valor;
        },
        getDescontroTriplo(valor, desconto1, desconto2, desconto3) {
            valor = valor - valor * (desconto1 / 100); // Primeiro desconto
            valor = valor - valor * (desconto2 / 100); // Descontro em cima do desconto anterior
            return valor;
        },
        getMotivo(obj){
            const motivo = obj.motivo ? obj.motivo.descricao : "--";
            return motivo;
        },
        getObsMotivo(obj){
            let obsMotivo = obj.motivoObservacao
            return obsMotivo;
        }
    },
};
</script>

<style lang="scss" scoped>
.data-table {
    padding: 0 12px;
}

.icon-position {
    padding: 0px;
}

.bar {
    border-radius: 100px;
    width: 5px;
    height: 100%;
    min-height: 25px;
    &.a-vencer {
        background-color: #f57c00;
    }
    &.vencidos {
        background-color: #d32f2f;
    }
}
</style>
